import React from 'react';
import { useTranslation } from 'react-i18next';
import { s } from '../helpers';

export interface SortOption {
  v: string;
  l: string;
}

export interface DashboardToolbarProps {
  search: string;
  onSearch: (e: React.ChangeEvent<HTMLInputElement>) => void;
  toggleFilters: () => void;
  filterBtnBorder: string;
  hasActiveFilters: boolean;
  activeFilterCount: number;
  sortKey: string;
  onSort: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  sortOptions: SortOption[];
  refresh: () => void;
  resetFilters: () => void;
  openAccess: () => void;
  hasUnclassified: boolean;
  openClassify: () => void;
}

export const DashboardToolbar: React.FC<DashboardToolbarProps> = ({
  search,
  onSearch,
  toggleFilters,
  filterBtnBorder,
  hasActiveFilters,
  activeFilterCount,
  sortKey,
  onSort,
  sortOptions,
  refresh,
  resetFilters,
  openAccess,
  hasUnclassified,
  openClassify
}) => {
  const { t } = useTranslation();

  return (
    <div style={s(`display:flex;flex-wrap:wrap;gap:10px;align-items:center`)}>
      <div
        style={s(
          `flex:1 1 320px;max-width:420px;height:40px;display:flex;align-items:center;gap:8px;padding:0 12px;background:#fff;border:1px solid #E3E6EA;border-radius:8px`
        )}
      >
        <i className="icon-search" style={s(`color:#6B7280;font-size:16px`)}></i>
        <input
          value={search}
          onChange={onSearch}
          placeholder={t('managerNetwork.toolbar.searchPlaceholder', 'Search by account ID, CM name, platform, alias...')}
          style={s(`border:0;outline:0;flex:1;min-width:0;font-size:14px;color:#1B2430;background:transparent`)}
        />
      </div>
      <button
        onClick={toggleFilters}
        style={s(
          `height:40px;padding:0 14px;border:1px solid ${filterBtnBorder};border-radius:8px;background:#fff;color:#1B2430;display:flex;align-items:center;gap:6px;font-size:14px;font-weight:500;cursor:pointer`
        )}
      >
        <i className="icon-filter"></i>{t('managerNetwork.toolbar.filter', 'Filter')}
        {Boolean(hasActiveFilters) && (
          <span style={s(`background:#F2A93B;color:#fff;border-radius:9px;font-size:11px;padding:1px 6px;font-weight:600`)}>
            {activeFilterCount}
          </span>
        )}
      </button>
      <label
        style={s(
          `height:40px;padding:0 10px 0 14px;border:1px solid #E3E6EA;border-radius:8px;background:#fff;color:#1B2430;display:flex;align-items:center;gap:6px;font-size:14px;font-weight:500;cursor:pointer`
        )}
      >
        <i className="icon-arrow-up-down"></i>
        <select
          value={sortKey}
          onChange={onSort}
          style={s(
            `border:0;outline:0;background:transparent;font-size:14px;font-weight:500;color:#1B2430;cursor:pointer;padding-right:4px`
          )}
        >
          {sortOptions?.map((o, o_idx) => (
            <React.Fragment key={o_idx}>
              <option value={o.v}>{o.l}</option>
            </React.Fragment>
          ))}
        </select>
      </label>
      <button
        onClick={refresh}
        title={t('managerNetwork.header.refresh', 'Refresh')}
        style={s(
          `width:40px;height:40px;border:1px solid #E3E6EA;border-radius:8px;background:#fff;color:#1B2430;display:flex;align-items:center;justify-content:center;cursor:pointer;font-size:16px`
        )}
      >
        <i className="icon-rotate-cw"></i>
      </button>
      <button
        onClick={resetFilters}
        style={s(
          `height:40px;padding:0 14px;border:1px solid #E3E6EA;border-radius:8px;background:#fff;color:#1B2430;display:flex;align-items:center;gap:6px;font-size:14px;font-weight:500;cursor:pointer`
        )}
      >
        <i className="icon-rotate-ccw"></i>{t('managerNetwork.toolbar.reset', 'Reset')}
      </button>
      <div style={s(`flex:1`)}></div>
      <button
        onClick={openAccess}
        style={s(
          `height:40px;padding:0 14px;border:1px solid #D9B97E;border-radius:8px;background:#fff;color:#8C6424;display:flex;align-items:center;gap:8px;font-size:14px;font-weight:600;cursor:pointer`
        )}
      >
        <i className="icon-user-plus"></i>{t('managerNetwork.toolbar.manageAccess', 'Manage Access')}
      </button>
      {Boolean(hasUnclassified) && (
        <button
          onClick={openClassify}
          style={s(
            `height:40px;padding:0 16px;border:0;border-radius:8px;background:#F2A93B;color:#0F1B2D;display:flex;align-items:center;gap:8px;font-size:14px;font-weight:600;cursor:pointer`
          )}
        >
          <i className="icon-tags"></i>{t('managerNetwork.toolbar.reviewAccounts', 'Review Accounts')}
        </button>
      )}
    </div>
  );
};
